import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
    wrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100% !important",
        padding: "0px",
    },
    '@global': {
        '.icon.active-friends': {
            filter: 'invert(48%) sepia(96%) saturate(2982%) hue-rotate(134deg) brightness(98%) contrast(101%) !important'
        },
        '.text.active-friends': {
            color: '#00BA6C !important'
        }
    },
});
